import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { List } from 'immutable';
import is from 'is_js';
import classnames from 'classnames';
import { Grid, PageCard, connect } from 'omni-common-ui';
import RadialScoreDisplay from 'components/RadialScoreDisplay';
import NoContentMessage from 'components/NoContentMessage';
import {
  actions as academicActions,
} from 'data/AcademicInfo';
import {
  actions as academicInfoSummaryActions,
} from 'data/AcademicInfo/Summary';
import OverviewBadge from './OverviewBadge';
import { ALL_GROUPS } from '../routes';

class AcademicInfoGroups extends PureComponent {
  componentDidMount() {
    this.props.fetchAcademicInfoGroupListIfNeeded(this._isAllGroups());
    this._fetchAcademicSummariesIfNeeded(this.props.academicInfoGroups);
  }

  componentWillReceiveProps(props) {
    props.fetchAcademicInfoGroupListIfNeeded(this._isAllGroups(props));
    this._fetchAcademicSummariesIfNeeded(props.academicInfoGroups);
  }

  _fetchAcademicSummariesIfNeeded(groups) {
    if (List.isList(groups)) {
      groups.forEach(({ id: groupId }) => {
        this.props.fetchAcademicInfoSummaryIfNeeded(groupId);
      });
    }
  }

  _isAllGroups(props = this.props) {
    return props.location.pathname.indexOf(ALL_GROUPS) > 0;
  }

  _renderOverviewBadge(academicInfoSummaryForGroup) {
    if (is.undefined(academicInfoSummaryForGroup)) {
      return null;
    }
    const {
      studentNumberWithLowerPTScore,
      studentNumberWithLowerSkillScore,
    } = academicInfoSummaryForGroup;
    return <OverviewBadge className={styles.AcademicInfoGroups_cardContent_badge}
        studentNumberWithLowerPTScore={studentNumberWithLowerPTScore}
        studentNumberWithLowerSkillScore={studentNumberWithLowerSkillScore} />;
  }

  _renderAcademicInfoDetail(summary) {
    if (! is.existy(summary) || ! is.existy(summary.progressTestAverageScore)) {
      const noDataClass = classnames(
        styles.AcademicInfoGroups_cardContent_info,
        styles.__empty
      );
      const noDataText = 'We\'re waiting for data!';
      return <div className={noDataClass}>{noDataText}</div>;
    }
    return <PageCard.Content className={styles.AcademicInfoGroups_cardContent}>
      {this._renderOverviewBadge(summary)}
      <div className={styles.AcademicInfoGroups_cardContent_info}>
        {summary &&
        <RadialScoreDisplay radius={25}
            circleStrokeWidth={2}
            edgeSize={70}
            forcedTextY={40}
            unit="percent"
            displayText
            circleStroke="transparent"
            formatText={(value) => `${value}%`}
            value={summary.progressTestAverageScore} />}
        Unit Quizs<br />
        Average Score
      </div>
    </PageCard.Content>;
  }

  _renderAcademicInfoGroup() {
    const { academicInfoGroups, academicInfoSummaries, buildRoute } = this.props;
    if (academicInfoGroups.size === 0) return;
    return academicInfoGroups.map((academicInfoGroup) => {
      const academicInfoSummaryForGroup = academicInfoSummaries.get(`${academicInfoGroup.id}`);
      return <Grid.Group key={academicInfoGroup.id}>
        <PageCard>
          <PageCard.Heading>
            <Link to={buildRoute(`/group/${academicInfoGroup.id}`)}
                draggable={false}>
              {`${academicInfoGroup.groupName} | ${academicInfoGroup.groupCode}`}
            </Link>
          </PageCard.Heading>
          <PageCard.Content className={styles.AcademicInfoGroups_cardContent}>
            {this._renderAcademicInfoDetail(academicInfoSummaryForGroup)}
          </PageCard.Content>
        </PageCard>
      </Grid.Group>;
    });
  }

  _renderNoCotentMessage() {
    if (this.props.academicInfoGroups.size > 0) return;
    return <NoContentMessage text="There are no groups on your schedule." />;
  }

  render() {
    return <Grid outerMargin>
      {this._renderAcademicInfoGroup()}
      {this._renderNoCotentMessage()}
    </Grid>;
  }
}

AcademicInfoGroups.propTypes = {
  fetchAcademicInfoGroupListIfNeeded: PropTypes.func.isRequired,
  fetchAcademicInfoSummaryIfNeeded: PropTypes.func.isRequired,
  academicInfoGroups: PropTypes.shape().isRequired,
  academicInfoSummaries: PropTypes.shape({
    get: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape().isRequired,
  buildRoute: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  let academicInfoGroups = state.get('rootReducer').get('academicInfoGroups').toList();
  if (ownProps.location.pathname.indexOf(ALL_GROUPS) < 0) {
    academicInfoGroups = academicInfoGroups.filter((academicInfoGroup) =>
      academicInfoGroup.isTodayGroup);
  }
  const academicInfoSummaries = state.get('rootReducer').get('academicInfoSummary');
  return {
    academicInfoGroups,
    academicInfoSummaries,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(bindActionCreators(academicActions, dispatch),
      bindActionCreators(academicInfoSummaryActions, dispatch));
}

export default connect(mapStateToProps, mapDispatchToProps)(AcademicInfoGroups);



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/AcademicInfoGroups/component.jsx